import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { TimelineItem } from "../../../../shared/timeline/timeline-item.model";

@Injectable()
export class AddressTimelineStateService {
  timelineItems = new BehaviorSubject<TimelineItem[]>([]);
}
